import { create } from 'zustand';

type Theme = 'light' | 'dark';

interface ThemeState {
  theme: Theme;
  hydrated: boolean;
  init: () => void;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

function applyTheme(theme: Theme) {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('dark', theme === 'dark');
}

function readStoredTheme(): Theme {
  if (typeof window === 'undefined') return 'light';
  const t = localStorage.getItem('theme');
  return t === 'dark' ? 'dark' : 'light';
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: 'light',
  hydrated: false,

  init: () => {
    if (get().hydrated) return; // ✅ защита
    const t = readStoredTheme();
    applyTheme(t);
    set({ theme: t, hydrated: true });
  },
  

  setTheme: (theme) => {
    if (typeof window !== 'undefined') localStorage.setItem('theme', theme);
    applyTheme(theme);
    set({ theme });
  },

  toggleTheme: () => {
    const next: Theme = get().theme === 'light' ? 'dark' : 'light';
    if (typeof window !== 'undefined') localStorage.setItem('theme', next);
    applyTheme(next);
    set({ theme: next });
  },
}));
